import React from 'react';

import * as S from './AlertPopup.styles';

export const AlertPopup = ({
  title,
  description,
  agreeText = 'Ok',
  cancelText = 'Отмена',
  dataTest,
  dataTestButton,
  onAgree,
  onCancel,
  onClose,
}) => {
  return (
    <S.StyledPopup dataTest={dataTest} onClose={onClose}>
      <S.Container>
        <S.Title>{title}</S.Title>
        <S.Description>
          <S.DescriptionText>{description}</S.DescriptionText>
        </S.Description>
        <S.ButtonsWrapper>
          {onCancel && <S.CancelButton onClick={onCancel}>{cancelText}</S.CancelButton>}
          {onAgree && (
            <S.AgreeButton onlyAgree={!onCancel} dataTest={dataTestButton} onClick={onAgree}>
              {agreeText}
            </S.AgreeButton>
          )}
        </S.ButtonsWrapper>
      </S.Container>
    </S.StyledPopup>
  );
};
